import { Tooltip } from "@mui/material";
import React from "react";

function CareTeamsList({ item }) {
  const tableHeaders = [
    { name: "Name" },
    { name: "Practitioner Role" },
    { name: "Care Team Role" },
    { name: "Speciality" },
  ];
  return (
    // <div class="pre_auth_detail_section">
    //   <div class="pre_auth-detail_section_head">
    //     <span>Care Teams</span>
    //   </div>
    //   <div class="pre_auth-detail_section_cont">
    //     <div class="pre_auth_communication_table">
    //       <table>
    //         <thead>
    //           <tr>
    //             {tableHeaders.map((el, index) => {
    //               return <th key={"tableHeaders_" + index}>{el.name}</th>;
    //             })}
    //           </tr>
    //         </thead>
    //         <tbody>
    //           {item?.getClaimTransaction?.data?.care_teams?.map((item) => (
    //             <tr key={item.id}>
    //               <td>{item.name}</td>
    //               <td>{item.practitioner_role}</td>
    //               <td>{item.care_team_role}</td>
    //               <td>{item.speciality}</td>
    //             </tr>
    //           ))}
    //         </tbody>
    //       </table>
    //     </div>
    //   </div>
    // </div>
    <div class="eligibility_details_section !p-0">
      <div className="eligibility_details_body_cont !p-0 !shadow-none !border-none">
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 !p-0 !shadow-none !border-none">
            {item?.getClaimTransaction?.data?.care_teams?.map((item) => (
              <div
                className="shadow-md rounded-lg p-3 gap-3 flex flex-col border border-black/20"
                key={item.id}
              >
                <div className="flex justify-between">
                  <dt className="text-sm font-semibold text-gray-600 my-auto">
                    Name
                  </dt>
                  <dd className=" text-sm text-gray-900 text-ellipsis overflow-hidden w-52 text-end capitalize">
                    {item?.name || "___"}
                  </dd>
                </div>

                <div className="flex justify-between">
                  <dt className="text-sm font-semibold text-gray-600 my-auto">
                    Practitioner Role
                  </dt>
                  <dd className=" text-sm text-gray-900 text-ellipsis overflow-hidden w-52 text-end">
                    {item?.practitioner_role || "___"}
                  </dd>
                </div>

                <div className="flex justify-between">
                  <dt className="text-sm font-semibold text-gray-600 my-auto">
                    Care Team Role
                  </dt>
                  <dd className=" text-sm text-gray-900 text-ellipsis overflow-hidden w-52 text-end">
                    {item?.care_team_role?.length > 100 ? (
                      <Tooltip title={item?.care_team_role}>
                        <span>{item?.care_team_role?.slice(0, 100)}...</span>
                      </Tooltip>
                    ) : (
                      item?.care_team_role
                    )}
                  </dd>
                </div>

                <div className="flex justify-between">
                  <dt className="text-sm font-semibold text-gray-600 my-auto">
                    Speciality
                  </dt>
                  <dd className=" text-sm text-gray-900 text-ellipsis overflow-hidden w-52 text-end capitalize">
                    {item?.speciality || "___"}
                  </dd>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <table className="min-w-full divide-y divide-gray-300">
      <thead className="bg-cyan-600">
        <tr>
          {tableHeaders.map((el, index) => {
            return (
              <th
                scope="col"
                className="whitespace-nowrap py-1 pl-4 pr-3 text-left text-sm font-semibold text-white sm:pl-2"
                key={"tableHeaders_" + index}
              >
                {el.name}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 bg-white">
        {item?.getClaimTransaction?.data?.care_teams?.map((item) => (
          <tr key={item.id}>
            <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
              {item.name}
            </td>
            <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
              {item.practitioner_role}
            </td>
            <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
              {item.care_team_role}
            </td>
            <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
              {item.qualification}
            </td>
            <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
              {item.speciality}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default CareTeamsList;
